<template>
  <div>
    <div
      v-if="isNavbarVisible"
      class="navbar relative bg-white has-border-bottom"
    >
      <div class="max-w-6xl mx-auto">
        <div class="navbar-header flex items-center sm:pr-6 px-5 py-4 justify-between">
          <div class="w-full lg:w-2/6">
            <a-link
              href="/client-portal"
              v-if="overviewLink"
            >
              <div
                class="flex items-center"
                v-if="company && company.logo && company.logo_url"
              >
                <img
                  class="h-12 w-auto logo"
                  @error="company.logo = false"
                  style="object-fit: scale-down; min-height: 100%"
                  :src="company.logo_url"
                  :alt="companyLogo"
                />
              </div>
              <span
                v-else-if="company && company.logo"
                class="flex items-center h-6 text-gray-900 hover:text-primary-600"
                >{{ companyLogo }}</span
              >
              <span
                v-else
                class="flex items-center"
              >
                <img
                  class="h-6 w-auto logo"
                  :src="'/images/black_logo.png'"
                  alt=""
                />
              </span>
            </a-link>
            <div v-else>
              <div
                class="flex items-center"
                v-if="company && company.logo && company.logo_url"
              >
                <img
                  class="h-12 w-auto logo"
                  @error="company.logo = false"
                  style="object-fit: scale-down; min-height: 100%"
                  :src="company.logo_url"
                  :alt="companyLogo"
                />
              </div>
              <span
                v-else-if="company && company.logo"
                class="flex items-center h-8 text-gray-900"
                >{{ companyLogo }}</span
              >
              <span
                v-else
                class="flex items-center"
              >
                <img
                  class="h-6 w-auto logo"
                  :src="'/images/black_logo.png'"
                  alt=""
                />
              </span>
            </div>
          </div>
          <div
            class="flex justify-end w-full lg:w-4/6"
            v-if="overviewLink"
          >
            <div class="flex items-center">
              <a-link
                href="/client-portal"
                :link-class="'text-gray-700'"
                class="nav-link sm:block flex items-center whitespace-nowrap"
              >
                <span class="flex items-center text-sm font-medium"> Dashboard </span>
              </a-link>
              <a-link
                href="#"
                :link-class="'text-gray-700'"
                class="ml-6 nav-link hidden sm:block items-center whitespace-nowrap"
                @click.prevent="showVideo = true"
              >
                <span class="flex items-center text-sm font-medium"> Tutorial Video </span>
              </a-link>
              <form
                action="/client-portal/logout"
                method="post"
                ref="logoutForm"
                class="ml-6"
              >
                <input
                  type="hidden"
                  name="_token"
                  :value="csrf"
                />
                <a-link
                  href="#"
                  :link-class="'text-gray-700'"
                  class="nav-link text-gray-800 flex items-center whitespace-nowrap group"
                  @click.prevent="logout"
                >
                  <span class="flex items-center text-sm font-medium"> Sign out </span>
                </a-link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="showVideo"
      @close="showVideo = false"
    >
      <div class="modal-video">
        <iframe
          src="https://www.loom.com/embed/530655545d6a4caba18b6e22adddb8ad"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        ></iframe>
      </div>
    </modal>
  </div>
</template>
<script>
import ALink from "../../UI/ALink.vue"
import Modal from "../../../js/components/Modal.vue"

export default {
  name: "Navbar",

  props: {
    overviewLink: { default: false, type: Boolean },
  },

  components: {
    ALink,
    Modal,
  },

  data() {
    return {
      csrf: window.FinancialCents.csrfToken,
      showVideo: false,
      company: window.FinancialCents.company || null,
    }
  },

  methods: {
    logout() {
      this.$refs.logoutForm.submit()
    },
  },

  computed: {
    companyLogo() {
      if (!this.company || !this.company.logo) {
        return "FinancialCents"
      }
      const name = this.company.name
      if (name.length <= 39) {
        return name
      }
      return name.substring(0, 39) + "..."
    },
    isVendorPortalRoute() {
      return this.$route?.path?.startsWith("/vendor-portal") || false
    },
    isNavbarVisible() {
      return !this.isVendorPortalRoute
    },
  },
}
</script>
<style scoped></style>
